import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { FaultCode } from '@vi-iot/client';

import { AppState } from '../app.state';

import { ActiveDeviceError } from './error-details.model';
import { ErrorDetailsState } from './error-details.state';

export namespace ErrorDetailsSelectors {
  export const errorDetails = (state: AppState): ErrorDetailsState => state.errorDetails;
  export const loading = createSelector(
    errorDetails,
    (state: ErrorDetailsState): boolean => state.loading
  );

  export const allErrorsDetailsLoading = createSelector(
    errorDetails,
    (state: ErrorDetailsState): boolean => state.allErrorsDetails.loading
  );
  export const allErrorsDetailsLoaded = createSelector(
    errorDetails,
    (state: ErrorDetailsState): boolean => state.allErrorsDetails.loaded
  );

  export function getState(): MemoizedSelector<
    AppState,
    ErrorDetailsState,
    DefaultProjectorFn<ErrorDetailsState>
  > {
    return createSelector(errorDetails, (state: ErrorDetailsState) => state);
  }

  export function getFullError(
    errorCode: string,
    languageCode: string
  ): MemoizedSelector<AppState, ActiveDeviceError, DefaultProjectorFn<ActiveDeviceError>> {
    return createSelector(errorDetails, (state: ErrorDetailsState) => {
      const errors = state.errors.find(
        (e) =>
          e.searchParams?.errorCode?.toLocaleLowerCase() === errorCode.toLocaleLowerCase() &&
          e.languageCode?.toLocaleLowerCase() === languageCode.toLocaleLowerCase()
      );

      return errors;
    });
  }

  export function getAllErrorsDetails(): MemoizedSelector<
    AppState,
    FaultCode[],
    DefaultProjectorFn<FaultCode[]>
  > {
    return createSelector(
      errorDetails,
      (state: ErrorDetailsState) => state.allErrorsDetails.allFaultCodes
    );
  }
}
